<template>
  <div id="processuser">
    <!-- {{PlugJson}} -->
    <van-tag
      type="primary"
      @click="showPopup"
    >{{'上报工作人员 ' + PlugJson.PlugBody.ProcessUserCount + ' 人'}}</van-tag>
    <van-popup
      v-model="monitorList"
      position="bottom"
      round
      closeable
      class="popup-l2"
      get-container="#app"
    >
      <van-nav-bar :title="'上报工作人员 ' + PlugJson.PlugBody.ProcessUserCount + ' 人'" left-text="列表" />
      <div class="mt-4 p-4">
        <van-cell
          v-for="(item,index) in PlugJson.PlugBody.ProcessUserList"
          :key="index"
          :value="item.Tel"
          class="text-left"
        >
          <template v-if="item.ReportNum==0">
            <template slot="title">{{item.RealName}}</template>
            <template slot="default">{{item.RoleName}}</template>
            <template slot="label">
              {{item.Phone}}
              <br />
              {{item.UserIDCard}}
            </template>
          </template>
          <template v-else>
            <template slot="title">{{item.RoleName}}</template>
            <template slot="default">{{item.UserCount}}</template>
          </template>
        </van-cell>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "processuser",
  data() {
    return {
      monitorList: false
    };
  },
  props: {
    PlugJson: Object
  },
  methods: {
    showPopup() {
      this.monitorList = true;
    }
  }
};
</script>

<style scoped>
</style>